<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-time"></i>
              材料工期管理
            </h1>
            <p class="page-subtitle">管理材料的工期时长配置，设置不同工期的折扣和描述信息</p>
          </div>
        </div>

        <!-- 操作按钮卡片 -->
        <div class="action-card">
          <div class="action-header">
            <h3 class="action-title">
              <i class="el-icon-s-tools"></i>
              操作面板
            </h3>
          </div>
          <div class="action-buttons">
            <el-tooltip effect="dark" content="添加工期时长" placement="top-start">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addButton()" class="action-btn">
                <i class="el-icon-plus"></i>
                添加工期
              </el-button>
            </el-tooltip>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
            <p class="search-subtitle">根据工期名称等条件筛选工期配置</p>
          </div>
          <el-form size="mini" :inline="true" :model="searchCondition" class="search-form">
            <el-form-item label="工期名称">
              <el-input 
                v-model="searchCondition.material_duration_name" 
                placeholder="请输入工期名称" 
                clearable
                prefix-icon="el-icon-time">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton" class="search-btn">
                <i class="el-icon-search"></i>
                查询
              </el-button>
              <el-button @click="resetSearch" class="reset-btn">
                <i class="el-icon-refresh"></i>
                重置
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
          <div class="table-header">
            <div class="header-left">
              <i class="el-icon-time"></i>
              <span>工期列表</span>
            </div>
            <div class="header-right">
              <el-tag type="info" size="mini">
                <i class="el-icon-info"></i>
                共 {{pagingData.total}} 条记录
              </el-tag>
            </div>
          </div>
          <ApeTable ref="apeTable" :data="dataList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column width="60" align="center" label="排序">
              <template slot-scope="scope">
                <el-tooltip effect="dark" content="拖动排序" placement="top">
                  <span class="drag-handle" :data-id="scope.row.id">
                    <i class="el-icon-rank"></i>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="80" label="序号" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" type="info">{{offset+scope.$index+1}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="工期信息" min-width="200">
              <template slot-scope="scope">
                <div class="duration-info">
                  <div class="info-row">
                    <i class="el-icon-time"></i>
                    <span class="info-label">工期名称：</span>
                    <span class="info-value name-text">{{scope.row.material_duration_name}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-s-data"></i>
                    <span class="info-label">工期时长：</span>
                    <el-tag size="mini" type="primary">{{scope.row.material_duration_value}}</el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="折扣信息" min-width="150">
              <template slot-scope="scope">
                <div class="duration-info">
                  <div class="info-row">
                    <i class="el-icon-discount"></i>
                    <span class="info-label">工期折扣：</span>
                    <el-tag :type="getDiscountType(scope.row.material_duration_discount)" size="mini">
                      {{scope.row.material_duration_discount}}%
                    </el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="工期描述" min-width="200">
              <template slot-scope="scope">
                <div class="duration-info">
                  <div class="info-row">
                    <i class="el-icon-document"></i>
                    <span class="info-label">描述：</span>
                    <el-tooltip :content="scope.row.material_duration_desc" placement="top" :disabled="!scope.row.material_duration_desc || scope.row.material_duration_desc.length <= 30">
                      <span class="info-value desc-text">{{scope.row.material_duration_desc | truncate(30)}}</span>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100" align="center">
              <template slot-scope="scope">
                <div class="status-column">
                  <span class="status-label">启用状态</span>
                  <el-switch 
                    v-model="scope.row.material_duration_status" 
                    :active-value="'1'" 
                    :inactive-value="'0'" 
                    active-color="#13ce66" 
                    inactive-color="#ff4949" 
                    @change="changeStatus(scope.row)">
                  </el-switch>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="120" label="操作" align="center">
              <template slot-scope="scope">
                <div class="action-buttons">
                  <el-tooltip effect="dark" content="编辑工期" placement="top">
                    <el-button size="mini" type="primary" icon="el-icon-edit" @click="editButton(scope.row.id)" class="action-btn-mini"></el-button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="dataForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="工期名称" prop="material_duration_name">
                <el-input v-model="formData.material_duration_name" placeholder="请输入工期名称">
                  <i slot="prefix" class="el-input__icon el-icon-time"></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="工期折扣" prop="material_duration_discount">
                <el-input v-model="formData.material_duration_discount" placeholder="请输入工期折扣百分比90就是90%" type="number" min="0" max="100">
                  <i slot="prefix" class="el-input__icon el-icon-discount"></i>
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="工期时长" prop="material_duration_value">
                <el-input v-model="formData.material_duration_value" placeholder="请输入工期时长" type="number" min="0">
                  <i slot="prefix" class="el-input__icon el-icon-s-data"></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="工期描述" prop="material_duration_desc">
                <el-input 
                  v-model="formData.material_duration_desc" 
                  type="textarea" 
                  :rows="4"
                  placeholder="请输入工期描述"
                  maxlength="200"
                  show-word-limit>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <I18nTranslatePanel entity-type="material_duration" :entity-id="formData.id || ''" />
        </el-form>     
      </template>
    </ApeDrawer>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
import Sortable from 'sortablejs'
import I18nTranslatePanel from '@/components/I18nTranslatePanel'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader,
    I18nTranslatePanel
  },
  data() {
    return {
      // 搜索条件
      searchCondition:{
        current_page: 1,
        page_size: 20,
        material_duration_name:'',
        query: "",
        params: [],
        order_by: 'material_duration_rank asc',
      },
      sortable: null,
      loadingStaus: true,
      // 表格列表数据
      dataList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        id:0
      },
      // 表单验证
      rules: {
        material_duration_name: [{required: true,message:'输入工期名称', trigger: 'blur' }],
        material_duration_value: [{required: true,message:'输入工期时长描述', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '580px',
      },
      rolesList: [],
      userRoles: []
      
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  filters: {
    truncate(text, maxLength) {
      if (!text) return ''
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength) + '...'
    }
  },
  methods: {
    // 获取折扣类型颜色
    getDiscountType(discount) {
      if (discount >= 90) return 'danger'
      if (discount >= 80) return 'warning'
      if (discount >= 70) return 'primary'
      return 'success'
    },
    // 重置搜索
    resetSearch() {
      this.searchCondition = {
        current_page: 1,
        page_size: 20,
        material_duration_name: '',
        query: "",
        params: [],
        order_by: 'material_duration_rank asc',
      }
      this.list()
    },
    // 搜索
    searchButton() {
      this.list()
    },
    // 切换页码操作
    async switchPaging() {
      this.list()
    },
    // 响应状态切换
    async changeStatus(row) {
       let res = await this.$api.post('/service/ola_app_material_duration/update',row)
       if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.list()
      }else{
        this.$message.error(res.message)
      }
    },
    // 响应添加按钮
    async addButton() {
      this.formData = {}
      this.drawerData.visible = true
      this.drawerData.title = '添加数据'
      this.drawerData.loading = false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑数据(ID:'+id+')'
      let res = await this.$api.post('/service/ola_app_material_duration/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let url = '/service/ola_app_material_duration/create'
      const isCreate = !(this.formData.id!=undefined && this.formData.id!='')
      if(!isCreate){
        url = '/service/ola_app_material_duration/update'
      }
      this.formData.material_id = this.$route.params.id
      if (isCreate) {
        this.formData.material_duration_rank = (this.pagingData.total || this.dataList.length || 0) + 1
      }
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.initFormData()
        this.list()
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      if(row.craft_status=='0'){
        row.craft_status='1'
      }else{
        row.craft_status='0'
      }
      let id = await this.$api.modifyMaterialDuration(row)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.list()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteMaterialDuration(id)
      if (info.info == null) {
        this.$message.success('删除成功!')
        this.$nextTick(async () => {
          this.list()
        })
      } else {
        this.$message.error(info)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {id:0}
        this.$refs['dataForm'].resetFields()
      })
    },
    // 初始化数据列表
    async list() {
      this.loadingStaus=true
      this.searchCondition.query= 'material_id=?'
      this.searchCondition.params = [this.$route.params.id]
      this.searchCondition.order_by = 'material_duration_rank asc'
      if (this.searchCondition.material_duration_name != ''){
        this.searchCondition.query = this.searchCondition.query+' and instr(material_duration_name,?)'
        this.searchCondition.params.push(this.searchCondition.material_duration_name)
      }
      Object.assign(this.searchCondition,this.pagingData)
      let res = await this.$api.post('/service/ola_app_material_duration/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.dataList=res.data.list
        this.pagingData.total = res.data.total
        this.$nextTick(() => {
          this.dragSort()
        })
      }else{
        this.dataList=[]
        this.pagingData.total = 0
        this.$message.error(res.message)
      }
      this.loadingStaus=false
    },
    async dragSortSubmit(orderIds) {
      let res = await this.$api.post('/service/ola_app_material_duration/order',{orderIds:orderIds,sort_field:'material_duration_rank'})
      if (this.$apiSuccess(res)){
        this.$message.success('排序成功!')
        this.list()
      }else{
        this.$message.error(res.message || '排序失败!')
      }
    },
    dragSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      if (!el) return
      if (this.sortable) {
        this.sortable.destroy()
        this.sortable = null
      }
      this.sortable = Sortable.create(el,{
        handle: ".drag-handle",
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: () => {
          let Ids = []
          let tmp = el.querySelectorAll('.drag-handle')
          for (let i=0,len=tmp.length; i < len; i++) {
            Ids.push(tmp[i].dataset.id)
          }
          this.dragSortSubmit(Ids)
        },
      })
    }
  },
  mounted() {
    this.list()
  },
}
</script>

<style lang="stylus" scoped>
  .main-page-content
    padding 24px
    min-height calc(100vh - 84px)
    background-color #f5f7fa

  // 页面标题区域
  .page-title-section
    background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
    border-radius 12px
    padding 32px
    margin-bottom 24px
    color white
    box-shadow 0 8px 32px rgba(102, 126, 234, 0.15)

  .title-content
    text-align center

  .page-title
    font-size 32px
    font-weight 600
    margin 0 0 8px 0
    display flex
    align-items center
    justify-content center
    gap 12px
    
    i
      font-size 36px

  .page-subtitle
    font-size 16px
    opacity 0.9
    margin 0
    line-height 1.5

  // 操作按钮卡片
  .action-card
    background white
    border-radius 12px
    padding 20px
    margin-bottom 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .action-header
    margin-bottom 16px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .action-title
    color #1f2937
    font-size 18px
    font-weight 600
    margin 0
    display flex
    align-items center
    gap 8px

  .action-buttons
    display flex
    flex-wrap wrap
    gap 8px

  .action-btn
    border-radius 8px
    font-weight 500
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 4px 12px rgba(0, 0, 0, 0.15)

  // 搜索卡片
  .search-card
    background white
    border-radius 12px
    padding 24px
    margin-bottom 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .search-header
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .search-title
    color #1f2937
    font-size 18px
    font-weight 600
    margin 0 0 4px 0
    display flex
    align-items center
    gap 8px

  .search-subtitle
    color #6b7280
    font-size 14px
    margin 0

  .search-form
    /deep/ .el-form-item
      margin-bottom 16px
      
    /deep/ .el-form-item__label
      color #374151
      font-weight 500

    /deep/ .el-input__inner
      border-radius 8px
      border 1px solid #d1d5db
      transition all 0.3s ease
      
      &:focus
        border-color #667eea
        box-shadow 0 0 0 3px rgba(102, 126, 234, 0.1)

  .search-btn
    background linear-gradient(45deg, #667eea, #764ba2)
    border none
    border-radius 8px
    padding 8px 16px
    font-weight 500
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 8px 25px rgba(102, 126, 234, 0.3)

  .reset-btn
    border-radius 8px
    padding 8px 16px
    margin-left 8px
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)

  // 表格卡片
  .table-card
    background white
    border-radius 12px
    padding 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .table-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .header-left
    display flex
    align-items center
    gap 8px
    font-size 18px
    font-weight 600
    color #1f2937
    
    i
      color #667eea
      font-size 20px

  .header-right
    .el-tag
      border-radius 6px
      font-weight 500

  // 工期信息样式
  .duration-info
    .info-row
      display flex
      align-items center
      margin-bottom 6px
      font-size 12px
      
      i
        color #667eea
        margin-right 6px
        font-size 14px
        width 14px
      
      .info-label
        color #6b7280
        margin-right 4px
        font-weight 500
        min-width 70px
      
      .info-value
        color #1f2937
        font-weight 500
        
        &.name-text
          color #1f2937
          font-weight 600
          
        &.desc-text
          color #6b7280
          font-size 11px

  // 状态列样式
  .status-column
    display flex
    flex-direction column
    align-items center
    gap 8px

  .status-label
    font-size 11px
    color #6b7280
    font-weight 500

  // 操作按钮样式
  .action-buttons
    display flex
    gap 4px
    justify-content center

  .action-btn-mini
    border-radius 6px
    transition all 0.3s ease
    
    &:hover
      transform translateY(-1px)
      box-shadow 0 4px 12px rgba(0, 0, 0, 0.15)

  .drag-handle
    font-size 18px
    cursor move
    color #409eff

    &:hover
      color #66b1ff

  // 表格样式优化
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background linear-gradient(45deg, #f8fafc, #f1f5f9)
      color #374151
      font-weight 600
      border-bottom 2px solid #e5e7eb
      
    td
      border-bottom 1px solid #f3f4f6
      
    tr:hover td
      background-color #f8fafc

  /deep/ .el-pagination
    margin-top 24px
    display flex
    justify-content center

  /deep/ .el-tag
    border-radius 6px
    font-weight 500

  /deep/ .el-switch
    margin 0

  // 表单样式优化
  /deep/ .el-input-group__append
    background-color #f5f7fa
    border-color #d1d5db
    color #374151

  // 响应式设计
  @media (max-width: 768px)
    .main-page-content
      padding 16px
      
    .page-title-section
      padding 24px 20px
      
    .page-title
      font-size 24px
      
    .action-card, .search-card, .table-card
      padding 16px
      
    .search-form
      /deep/ .el-form-item
        display block
        margin-bottom 12px
        
    .table-header
      flex-direction column
      gap 12px
      align-items flex-start

    .action-buttons
      flex-direction column
      gap 8px

  // 兼容原有样式
  .el-button
    margin-right 4px
    margin-bottom 4px
    
  .table-header
    margin-bottom 12px
    
  .el-input-group__prepend, .el-input-group__append
    background #ffffff
    padding 0 12px
    
  .el-input-group__append
    color #ffffff
    background #1890ff
    
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
    
  .el-select > .el-input 
    width 300px
</style>
